// src/components/ui/dashboard/dashboard-header.tsx
"use client"

import { useState } from "react"
import { useNavigate } from "react-router";
import { Search, Bell } from "lucide-react"
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"
import { NotificationsModal } from "@/components/ui/notifications/notifications-modal"
import { useThemeStore } from "@/hooks/stores/themeStore"

interface DashboardHeaderProps {
  userName?: string
  userImage?: string
}

export function DashboardHeader({
  userName = "Ade Ronke",
  userImage = "/aderonke.jpg",
}: DashboardHeaderProps) {
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)
  const navigate = useNavigate();
  const currentTheme = useThemeStore((state) => state.getCurrentTheme());

  // Mock function to handle marking notifications as read
  const handleMarkAsRead = (notificationId: string) => {
    console.log("Marking notification as read:", notificationId)
    // Implement your logic to mark notification as read
  }

  const handleMarkAllAsRead = () => {
    console.log("Marking all notifications as read")
    // Implement your logic to mark all notifications as read
  }

  const handleAvatarClick = () => {
    navigate("/profile")
  }

  return (
    <>
      <header className="flex justify-between items-center mb-8">
        <div>
          <h2
            className="text-3xl font-bold"
            style={{ color: 'var(--theme-foreground)' }}
          >
            Dashboard
          </h2>
          <p style={{ color: 'var(--theme-foreground)', opacity: 0.8 }}>
            Welcome back, {userName}!
          </p>
        </div>
        <div className="flex items-center gap-4">

          {/* Notifications Bell */}
          <div className="relative">
            <button
              onClick={() => setIsNotificationsOpen(true)}
              className="relative p-2 rounded-full transition"
              style={{
                backgroundColor: 'var(--theme-muted)',
                color: 'var(--theme-foreground)'
              }}
            >
              <Bell className="w-6 h-6" />
              <span
                className="absolute top-1 right-1 block h-2 w-2 rounded-full"
                style={{ backgroundColor: currentTheme.colors.primary }}
              ></span>
            </button>
          </div>

          {/* Avatar with click handler */}
          <button
            onClick={handleAvatarClick}
            className="transition-transform hover:scale-105 focus:outline-none rounded-full"
            style={{
              border: `1px solid ${currentTheme.colors.primary}`,
              boxShadow: `0 0 0 2px ${currentTheme.colors.primary}20`
            }}
          >
            <Avatar className="w-8 h-8 cursor-pointer">
              <AvatarImage src={userImage || "/placeholder.svg"} alt={userName} />
              <AvatarFallback style={{ color: currentTheme.colors.primary }}>
                {userName.charAt(0)}
              </AvatarFallback>
            </Avatar>
          </button>
        </div>
      </header>

      {/* Notifications Modal */}
      <NotificationsModal
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
        onMarkAsRead={handleMarkAsRead}
        onMarkAllAsRead={handleMarkAllAsRead}
        position="top-right"
        themeColors={currentTheme.colors}
      />
    </>
  )
}